import { env } from "env"
import { CollegeName } from "data"

// https://docs.tealium.com/platforms/javascript/install/
export const tealiumInit = ({
  collegeName,
  isAuthPage,
}: {
  collegeName: CollegeName
  isAuthPage?: boolean
}) => {
  const tealiumAccount = "rvaed"
  const tealiumEnv = isAuthPage ? "prod" : env.VITE_TEALIUM_TARGET_ENV
  const tealiumProfile = tealiumEnv === "prod" ? collegeName : "sandbox"
  const tealiumURL = `https://tags.tiqcdn.com/utag/${tealiumAccount}/${tealiumProfile}/${tealiumEnv}/utag.js`

  const existingScript = document.querySelector(`script[src="${tealiumURL}"]`)
  if (existingScript) {
    return { cleanup: () => {} }
  }

  return new Promise<void>(resolve => {
    // Create script element
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src = tealiumURL
    script.async = true

    // Add window.utag initialization
    const initScript = document.createElement("script")
    initScript.type = "text/javascript"
    initScript.textContent =
      "window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};"

    // Insert initialization script first
    const firstScript = document.getElementsByTagName("script")[0]
    if (!firstScript.parentNode) {
      throw new Error("Could not find parent node for script insertion")
    }
    firstScript.parentNode.insertBefore(initScript, firstScript)

    // Then insert Tealium script
    firstScript.parentNode.insertBefore(script, initScript.nextSibling)

    // Wait for script to load
    script.onload = () => {
      resolve()
    }

    return {
      cleanup: () => {
        script.parentNode?.removeChild(script)
        initScript.parentNode?.removeChild(initScript)
      },
    }
  })
}
